import script from "./control-weather.vue?vue&type=script&setup=true&lang=ts"
export * from "./control-weather.vue?vue&type=script&setup=true&lang=ts"

import "./control-weather.vue?vue&type=style&index=0&id=00024e5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00024e5c"]])

export default __exports__